import { Info } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import type { ReactNode } from "react";

interface EstimateRowProps {
  label: string;
  tooltipText: string;
  value: ReactNode;
  valueClassName: string;
  isLoading: boolean;
}

export function EstimateRow({
  label,
  tooltipText,
  value,
  valueClassName,
  isLoading,
}: EstimateRowProps) {
  return (
    <div className="flex items-center justify-between px-2.5">
      <div className="flex items-center gap-x-0.5">
        <span className="text-button-sm text-black-600">{label}</span>
        <Tooltip>
          <TooltipTrigger>
            <Info weight="fill" className="text-black-300 size-4" />
          </TooltipTrigger>
          <TooltipContent>{tooltipText}</TooltipContent>
        </Tooltip>
      </div>
      {isLoading ? (
        <Skeleton className="w-24 h-5" />
      ) : (
        <span className={valueClassName}>{value}</span>
      )}
    </div>
  );
}
